import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { EnumDescriptor } from '../../enum-descriptor';
import { OperatorState } from '@proxy/operators';

@Component({
    selector: 'app-operator-state-dropdown',
    templateUrl: './operator-state-dropdown.component.html',
    standalone: false
})
export class OperatorStateDropdownComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() operatorState: OperatorState;

  @Output() changeOperatorState = new EventEmitter<OperatorState>();

  operatorStates: EnumDescriptor[];

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.isNullOrUndefined(this.operatorState)) {
      this.operatorState = OperatorState.Active;
    }

    this.loadOperatorState();
    this.onSelected();
  }

  loadOperatorState(): void {
    this.operatorStates = this.getEnumOptions(OperatorState, false);
  }

  onSelected(): void {
    this.changeOperatorState.emit(this.operatorState);
  }
}
